module.exports = new __parcel__URL__("list-preview-dark.e53f1bb5.svg").toString();